<div class="global-categories-tab">
  <div class="toolbar d-flex justify-content-between align-items-center mb-3" *ngIf="isAdmin">
    <p class="text-muted mb-0 small">Platform-wide category tree for the Global Product Catalog.</p>
    <button type="button" class="btn btn-primary btn-sm" (click)="openAddRoot()">
      <nb-icon icon="plus-outline"></nb-icon> Add root category
    </button>
  </div>

  <div class="loading-container" *ngIf="loading">
    <p class="text-muted">Loading categories…</p>
  </div>

  <div class="empty-state" *ngIf="!loading && categories.length === 0">
    <nb-icon icon="folder-outline" class="empty-icon"></nb-icon>
    <h3>No global categories yet</h3>
    <p *ngIf="isAdmin">Create a root category to organize global products.</p>
    <p *ngIf="!isAdmin">No global categories have been defined.</p>
    <button *ngIf="isAdmin" class="btn btn-primary" (click)="openAddRoot()">Add root category</button>
  </div>

  <div class="table-container" *ngIf="!loading && categories.length > 0">
    <table class="products-table">
      <thead>
        <tr>
          <th>Name</th>
          <th>Slug</th>
          <th>Products</th>
          <th>Visible</th>
          <th>Status</th>
          <th *ngIf="isAdmin">Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let cat of categories">
          <td><span [style.padding-left.px]="(cat.depth || 0) * 20">{{ cat.name }}</span></td>
          <td><code class="small">{{ cat.slug }}</code></td>
          <td>{{ cat.productCount ?? 0 }}</td>
          <td>
            <span class="status-chip" [ngClass]="cat.isVisible !== false ? 'chip-info' : 'chip-neutral'">
              {{ cat.isVisible !== false ? 'Yes' : 'No' }}
            </span>
          </td>
          <td>
            <span class="status-chip" [ngClass]="cat.status === 1 ? 'chip-info' : 'chip-warn'">
              {{ cat.status === 1 ? 'Active' : 'Inactive' }}
            </span>
          </td>
          <td class="actions-cell" *ngIf="isAdmin">
            <button class="btn btn-sm btn-outline-secondary" title="Add child" (click)="openAddChild(cat)">
              <nb-icon icon="plus-outline"></nb-icon>
            </button>
            <button class="btn btn-sm btn-outline-primary" title="Edit" (click)="openEdit(cat)">
              <nb-icon icon="edit-2-outline"></nb-icon>
            </button>
            <button class="btn btn-sm btn-outline-secondary" title="Move up" (click)="moveUp(cat)" [disabled]="!canMoveUp(cat)">
              <nb-icon icon="arrow-up-outline"></nb-icon>
            </button>
            <button class="btn btn-sm btn-outline-secondary" title="Move down" (click)="moveDown(cat)" [disabled]="!canMoveDown(cat)">
              <nb-icon icon="arrow-down-outline"></nb-icon>
            </button>
            <button class="btn btn-sm btn-outline-danger" title="Delete" (click)="deleteCategory(cat)">
              <nb-icon icon="trash-2-outline"></nb-icon>
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
